const MuiButton = {
  styleOverrides: {
    root: {
      color: "#C2C4CC",
      "&.Mui-checked": {
        color: "#1A1A1A",
      }
    },
  },
};

export default MuiButton;
